import ticketApi from "@api/ticket"
import { useMutation } from "@tanstack/react-query"

const useDownloadTicket = (ticketUuid: string) => {
    return useMutation({
        mutationFn: async () => {
            return await ticketApi.printTicket(ticketUuid)
        },
    })
}

export default useDownloadTicket;